module.exports = __webpack_public_path__ + "static/img/joinKerry.08ac4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinKerry.png
// module id = ipXd
// module chunks = 1